// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.UpdateReleaseType in deviceSettings/deviceSettings.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.EnumAdapter
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireEnum
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.JvmStatic
import kotlin.Int
import kotlin.Suppress

/**
 * Device update type, represents update/software stability
 */
public enum class UpdateReleaseType(
  override val `value`: Int,
) : WireEnum {
  /**
   * Latest release aimed for internal testing
   */
  ALPHA(0),
  /**
   * Latest release for beta customers with some potential bugs
   */
  BETA(1),
  /**
   * Latest stable release safe to be used by all customers
   */
  STABLE(2),
  ;

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<UpdateReleaseType> = object : EnumAdapter<UpdateReleaseType>(
      UpdateReleaseType::class, 
      PROTO_3, 
      UpdateReleaseType.ALPHA
    ) {
      override fun fromValue(`value`: Int): UpdateReleaseType? = UpdateReleaseType.fromValue(`value`)
    }

    @JvmStatic
    public fun fromValue(`value`: Int): UpdateReleaseType? = when (`value`) {
      0 -> ALPHA
      1 -> BETA
      2 -> STABLE
      else -> null
    }
  }
}
